import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/projects/rock-paper-scissors', 
      name: 'rock-paper-scissors',
      component: () => import(/* webpackChunkName: "RockPaperScissors" */ './views/RockPaperScissors.vue')
    },
    {
      path: '/projects/simon',
      name: 'simon',
      component: () => import(/* webpackChunkName: "Simon" */ './views/Simon.vue')
    },
    { 
      path: '*', 
      component: Home 
    }
  ]
})
